import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OnlyLettersDirective } from '../../directives/only-letters.directive';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive'; 
import { HelperService } from '../../shared/services/helper.service';
import { LoadingComponent } from '../components/loading/loading.component';
import { TipoDocumentoDirective } from '../../directives/tipo-documento.directive';
import { MountFormatPipe } from '../../pipes/mount-format.pipe';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { MatMomentDateModule} from '@angular/material-moment-adapter'
import { MatStepperModule, MatInputModule, 
    MatButtonModule, MatAutocompleteModule, 
    MatSelectModule, MatDatepickerModule,
    MatNativeDateModule, MatGridListModule,
    MatCardModule, MatExpansionModule,
    MatTableModule, MatTabsModule,
    MatCheckboxModule, MatIconModule } from '@angular/material';
import { MatDividerModule } from '@angular/material/divider';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { TableModule} from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu'; 
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FieldsetModule } from 'primeng/fieldset';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { SidebarModule } from 'primeng/sidebar';
import { ExcelService } from '../../services/excel.service';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { FormService } from '../services/validation.service';
import { InputTextareaModule } from 'primeng/inputtextarea';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,

    MatStepperModule,
    MatInputModule,
    MatButtonModule,
    MatAutocompleteModule, 
    MatDividerModule,
    MatSelectModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatGridListModule,
    MatDatepickerModule,
    MatCardModule,
    FileUploadModule,
    MatExpansionModule,
    MatTableModule,
    MatTabsModule,
    MatCheckboxModule,
    MatIconModule,        
    //primeNg
    TableModule,
    ButtonModule,
    ToastModule,
    PanelModule,
    TabViewModule,
    SplitButtonModule,
    MenuModule,
    InputTextModule,
    CheckboxModule,
    KeyFilterModule,
    DialogModule,
    DropdownModule,
    ToolbarModule,
    OverlayPanelModule,
    TooltipModule,
    AutoCompleteModule,
    FieldsetModule,
    ConfirmDialogModule,
    ProgressBarModule,
    SidebarModule,
    RadioButtonModule,
    CalendarModule,
    InputTextareaModule
  ],
  declarations: [
    OnlyLettersDirective,
    OnlyNumbersDirective,
    TipoDocumentoDirective,
    LoadingComponent,
    MountFormatPipe,
    DateFormatPipe
  ],
  providers: [
    HelperService,
    MessageService,
    ConfirmationService,
    ExcelService,
    FormService
  ],
  exports: [
    OnlyLettersDirective,
    OnlyNumbersDirective,
    TipoDocumentoDirective,
    CommonModule,
    ModalModule,
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingComponent,
    BrowserAnimationsModule,
    MountFormatPipe,
    DateFormatPipe,
    MatDatepickerModule,
    MatStepperModule,
    MatInputModule,
    MatButtonModule,
    MatAutocompleteModule, 
    MatDividerModule,
    MatSelectModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatGridListModule,
    MatCardModule,
    FileUploadModule,
    MatExpansionModule,
    MatTableModule,
    MatTabsModule,
    MatCheckboxModule,
    MatIconModule,        
    //primeNg
    TableModule,
    ButtonModule,
    ToastModule,
    PanelModule,
    TabViewModule,
    SplitButtonModule,
    MenuModule,
    InputTextModule,
    CheckboxModule,
    KeyFilterModule,
    DialogModule,
    DropdownModule,
    ToolbarModule,
    OverlayPanelModule,
    TooltipModule,
    AutoCompleteModule,
    FieldsetModule,
    ConfirmDialogModule,
    ProgressBarModule,
    SidebarModule,
    RadioButtonModule,
    CalendarModule,
    InputTextareaModule
  ]
})

export class SharedModule {

}
